import React from 'react';

import { translate } from '../../commons/localize';

import './LoadingComponent.css';

const LoadingComponent = () => (
  <div className="loading-container">
    <div className="spinner-border loading-logo" role="status">
      <span className="sr-only">{translate('LOADING_TXT')}...</span>
    </div>
  </div>
);

export default LoadingComponent;
